import state from './moduleCalculatorState.js'
import mutations from './moduleCalculatorMutations.js'
import actions from './moduleCalculatorActions.js'
import getters from './moduleCalculatorGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
